export const STAFF_LOCATION_ACCESS_STORAGE_KEY = "staffLocationAccess";
